import { render, staticRenderFns } from "./RegistrarMixer.vue?vue&type=template&id=50760b94&scoped=true&"
import script from "./RegistrarMixer.vue?vue&type=script&lang=js&"
export * from "./RegistrarMixer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50760b94",
  null
  
)

export default component.exports